var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingcart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3667 8.16658C10.8667 8.16658 11.3067 7.89325 11.5334 7.47992L13.9201 3.15325C14.1667 2.71325 13.8467 2.16659 13.3401 2.16659H3.47341L2.84675 0.833252H0.666748V2.16659H2.00008L4.40008 7.22658L3.50008 8.85325C3.01341 9.74658 3.65341 10.8333 4.66675 10.8333H12.6667V9.49992H4.66675L5.40008 8.16658H10.3667ZM4.10675 3.49992H12.2067L10.3667 6.83325H5.68675L4.10675 3.49992ZM4.66675 11.4999C3.93341 11.4999 3.34008 12.0999 3.34008 12.8333C3.34008 13.5666 3.93341 14.1666 4.66675 14.1666C5.40008 14.1666 6.00008 13.5666 6.00008 12.8333C6.00008 12.0999 5.40008 11.4999 4.66675 11.4999ZM11.3334 11.4999C10.6001 11.4999 10.0067 12.0999 10.0067 12.8333C10.0067 13.5666 10.6001 14.1666 11.3334 14.1666C12.0667 14.1666 12.6667 13.5666 12.6667 12.8333C12.6667 12.0999 12.0667 11.4999 11.3334 11.4999Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingcart);
export default __webpack_public_path__ + "static/media/shoppingcart.33c4dc5b2c354d665af6bea17b2f8e26.svg";
export { ForwardRef as ReactComponent };